// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── CSS Variables — Dark Theme (default) ───────────────────────────── */
:root {
  --bg-base:      #0f1117;
  --bg-surface:   #1a1d27;
  --bg-elevated:  #22263a;
  --bg-hover:     #2a2f47;

  --accent:       #6366f1;
  --accent-light: #818cf8;
  --accent-dim:   rgba(99,102,241,0.15);

  --success:      #10b981;
  --warning:      #f59e0b;
  --danger:       #ef4444;
  --info:         #3b82f6;

  --text-primary:   #f1f5f9;
  --text-secondary: #94a3b8;
  --text-muted:     #64748b;

  --border:       rgba(255,255,255,0.07);
  --border-focus: rgba(99,102,241,0.5);

  --radius-sm:  6px;
  --radius:     10px;
  --radius-lg:  16px;

  --shadow-sm: 0 1px 3px rgba(0,0,0,0.4);
  --shadow:    0 4px 20px rgba(0,0,0,0.5);
  --shadow-lg: 0 8px 40px rgba(0,0,0,0.6);

  --sidebar-w: 240px;
  --sidebar-w-collapsed: 68px;

  --transition: 0.2s ease;
}

/* ─── CSS Variables — Light Theme ────────────────────────────────────── */
body.light-theme {
  --bg-base:      #f0f2f8;
  --bg-surface:   #ffffff;
  --bg-elevated:  #f8f9fc;
  --bg-hover:     #e8eaf2;

  --accent:       #6366f1;
  --accent-light: #4f46e5;
  --accent-dim:   rgba(99,102,241,0.10);

  --success:      #059669;
  --warning:      #d97706;
  --danger:       #dc2626;
  --info:         #2563eb;

  --text-primary:   #0f172a;
  --text-secondary: #475569;
  --text-muted:     #94a3b8;

  --border:       rgba(0,0,0,0.08);
  --border-focus: rgba(99,102,241,0.4);

  --shadow-sm: 0 1px 3px rgba(0,0,0,0.08);
  --shadow:    0 4px 20px rgba(0,0,0,0.10);
  --shadow-lg: 0 8px 40px rgba(0,0,0,0.14);
}

/* Light theme overrides for specific components */
body.light-theme .sidebar             { background: #ffffff; border-right: 1px solid rgba(0,0,0,0.08); }
body.light-theme .sidebar-logo        { color: #4f46e5; }
body.light-theme .sidebar-link        { color: #475569; }
body.light-theme .sidebar-link:hover  { background: rgba(99,102,241,0.08); color: #4f46e5; }
body.light-theme .sidebar-link.active { background: rgba(99,102,241,0.12); color: #4f46e5; }
body.light-theme .sidebar-section-title { color: #94a3b8; }
body.light-theme .app-header          { background: #ffffff; border-bottom: 1px solid rgba(0,0,0,0.08); box-shadow: 0 1px 8px rgba(0,0,0,0.06); }
body.light-theme .data-table thead tr { background: #f1f3f9; }
body.light-theme .data-table tbody tr:hover { background: #f5f7ff; }
body.light-theme input,
body.light-theme select,
body.light-theme textarea             { background: #fff; border-color: rgba(0,0,0,0.12); color: #0f172a; }
body.light-theme input::placeholder,
body.light-theme textarea::placeholder { color: #94a3b8; }
body.light-theme .card                { background: #ffffff; border-color: rgba(0,0,0,0.07); }
body.light-theme .card-header         { background: #f8f9fc; border-bottom-color: rgba(0,0,0,0.07); }
body.light-theme .modal               { background: #ffffff; }
body.light-theme .modal-header        { background: #f8f9fc; }
body.light-theme .theme-toggle-btn    { background: rgba(0,0,0,0.05); }


/* ─── Reset ───────────────────────────────────────────────────────────── */
*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

html { font-size: 15px; scroll-behavior: smooth; }

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  background: var(--bg-base);
  color: var(--text-primary);
  line-height: 1.6;
  min-height: 100vh;
  -webkit-font-smoothing: antialiased;
}

a { color: var(--accent-light); text-decoration: none; }
a:hover { color: var(--accent); }
input, select, textarea, button { font-family: inherit; }
img { max-width: 100%; }

/* ─── Scrollbar ───────────────────────────────────────────────────────── */
::-webkit-scrollbar       { width: 6px; height: 6px; }
::-webkit-scrollbar-track { background: transparent; }
::-webkit-scrollbar-thumb { background: var(--bg-elevated); border-radius: 3px; }

/* ─── Layout ──────────────────────────────────────────────────────────── */
.app-layout {
  display: flex;
  min-height: 100vh;
}

.main-content {
  flex: 1 1;
  margin-left: var(--sidebar-w);
  min-height: 100vh;
  padding-top: 56px; /* header height */
  transition: margin-left var(--transition);
  background: var(--bg-base);
}
.main-content.sidebar-collapsed { margin-left: var(--sidebar-w-collapsed); }

/* ─── App Header Bar ───────────────────────────────────────────────────── */
.app-header {
  position: fixed;
  top: 0;
  left: var(--sidebar-w);
  right: 0;
  height: 56px;
  background: var(--bg-surface);
  border-bottom: 1px solid var(--border);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 24px;
  gap: 12px;
  z-index: 100;
  transition: left var(--transition), background var(--transition);
  box-shadow: var(--shadow-sm);
}
.app-header.sidebar-collapsed { left: var(--sidebar-w-collapsed); }

.header-page-title {
  flex: 1 1;
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--text-muted);
  letter-spacing: 0.02em;
}

/* Theme toggle button */
.theme-toggle-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 16px;
  background: var(--bg-elevated);
  border: 1px solid var(--border);
  border-radius: 50px;
  color: var(--text-secondary);
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s ease;
  white-space: nowrap;
  outline: none;
  -webkit-user-select: none;
          user-select: none;
}
.theme-toggle-btn:hover {
  background: var(--accent-dim);
  border-color: var(--border-focus);
  color: var(--accent-light);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(99,102,241,0.2);
}
.theme-toggle-btn .toggle-icon { font-size: 1rem; line-height: 1; transition: transform 0.4s ease; }
.theme-toggle-btn:hover .toggle-icon { transform: rotate(20deg); }

/* Header user info */
.header-user {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-secondary);
  font-size: 0.82rem;
}
.header-user-avatar {
  width: 30px; height: 30px;
  border-radius: 50%;
  background: var(--accent-dim);
  border: 1px solid var(--border-focus);
  display: flex; align-items: center; justify-content: center;
  font-size: 0.78rem; font-weight: 700; color: var(--accent-light);
  flex-shrink: 0;
}

/* ─── Sidebar ─────────────────────────────────────────────────────────── */
.sidebar {
  position: fixed;
  top: 0; left: 0;
  width: var(--sidebar-w);
  height: 100vh;
  background: var(--bg-surface);
  border-right: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  z-index: 100;
  transition: width var(--transition);
  overflow: hidden;
}
.sidebar.collapsed { width: var(--sidebar-w-collapsed); }

.sidebar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 16px;
  border-bottom: 1px solid var(--border);
  min-height: 68px;
  flex-shrink: 0;
}
.sidebar-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.05rem;
  font-weight: 700;
  background: linear-gradient(135deg, var(--accent), var(--accent-light));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  white-space: nowrap;
}
.sidebar-logo .logo-icon {
  font-size: 1.5rem;
  -webkit-text-fill-color: initial;
}
.sidebar-toggle {
  background: none;
  border: none;
  color: var(--text-muted);
  cursor: pointer;
  padding: 6px;
  border-radius: var(--radius-sm);
  font-size: 1rem;
  line-height: 1;
  flex-shrink: 0;
  transition: color var(--transition), background var(--transition);
}
.sidebar-toggle:hover { color: var(--text-primary); background: var(--bg-elevated); }

.sidebar-nav {
  flex: 1 1;
  padding: 12px 8px;
  overflow-y: auto;
  overflow-x: hidden;
}
.sidebar-link {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: var(--radius);
  color: var(--text-secondary);
  font-size: 0.875rem;
  font-weight: 500;
  white-space: nowrap;
  transition: all var(--transition);
  margin-bottom: 2px;
  position: relative;
}
.sidebar-link:hover { color: var(--text-primary); background: var(--bg-elevated); }
.sidebar-link.active {
  color: var(--accent-light);
  background: var(--accent-dim);
}
.sidebar-link.active::before {
  content: '';
  position: absolute;
  left: 0; top: 20%; bottom: 20%;
  width: 3px;
  background: var(--accent);
  border-radius: 0 2px 2px 0;
}
.sidebar-icon { font-size: 1.1rem; flex-shrink: 0; }
.sidebar-label { overflow: hidden; }

.sidebar-section-title {
  font-size: 0.65rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--text-muted);
  padding: 12px 12px 4px;
  white-space: nowrap;
  overflow: hidden;
}

.sidebar-footer {
  padding: 12px 8px;
  border-top: 1px solid var(--border);
  flex-shrink: 0;
}
.sidebar-user {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: var(--radius);
  margin-bottom: 4px;
}
.user-avatar-sm {
  width: 34px; height: 34px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--accent), #a78bfa);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
  font-weight: 700;
  color: #fff;
  flex-shrink: 0;
}
.user-info { overflow: hidden; }
.user-info .user-name {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--text-primary);
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.user-info .user-role {
  font-size: 0.7rem;
  color: var(--text-muted);
  text-transform: capitalize;
}
.logout-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 9px 12px;
  background: none;
  border: none;
  border-radius: var(--radius);
  color: var(--text-secondary);
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all var(--transition);
  white-space: nowrap;
  overflow: hidden;
}
.logout-btn:hover { color: var(--danger); background: rgba(239,68,68,0.1); }

/* ─── Page layout ─────────────────────────────────────────────────────── */
.page {
  padding: 28px 32px;
  max-width: 1400px;
  margin: 0 auto;
}
.page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 28px;
  gap: 16px;
  flex-wrap: wrap;
}
.page-title {
  font-size: 1.6rem;
  font-weight: 700;
  color: var(--text-primary);
  line-height: 1.2;
}
.page-subtitle {
  font-size: 0.875rem;
  color: var(--text-muted);
  margin-top: 4px;
}
.page-actions { display: flex; gap: 10px; flex-wrap: wrap; align-items: center; }

/* ─── Cards ───────────────────────────────────────────────────────────── */
.card {
  background: var(--bg-surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  overflow: hidden;
}
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 22px;
  border-bottom: 1px solid var(--border);
  gap: 12px;
  flex-wrap: wrap;
}
.card-title {
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text-primary);
}
.card-body { padding: 22px; }

/* ─── Stat Cards ──────────────────────────────────────────────────────── */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
  gap: 16px;
  margin-bottom: 28px;
}
.stat-card {
  background: var(--bg-surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 20px 22px;
  display: flex;
  align-items: center;
  gap: 16px;
  transition: transform var(--transition), box-shadow var(--transition);
  cursor: default;
}
.stat-card:hover { transform: translateY(-2px); box-shadow: var(--shadow); }
.stat-icon {
  width: 48px; height: 48px;
  border-radius: var(--radius);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
  flex-shrink: 0;
}
.stat-value {
  font-size: 1.7rem;
  font-weight: 800;
  color: var(--text-primary);
  line-height: 1;
  display: block;
}
.stat-label {
  font-size: 0.75rem;
  color: var(--text-muted);
  margin-top: 4px;
  display: block;
}
.stat-card--blue   .stat-icon { background: rgba(59,130,246,0.15);  color: #3b82f6; }
.stat-card--green  .stat-icon { background: rgba(16,185,129,0.15);  color: #10b981; }
.stat-card--purple .stat-icon { background: rgba(139,92,246,0.15);  color: #8b5cf6; }
.stat-card--orange .stat-icon { background: rgba(245,158,11,0.15);  color: #f59e0b; }
.stat-card--red    .stat-icon { background: rgba(239,68,68,0.15);   color: #ef4444; }
.stat-card--cyan   .stat-icon { background: rgba(6,182,212,0.15);   color: #06b6d4; }

/* ─── Buttons ─────────────────────────────────────────────────────────── */
.btn {
  display: inline-flex; align-items: center; gap: 7px;
  padding: 9px 18px;
  border-radius: var(--radius);
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  border: none;
  transition: all var(--transition);
  white-space: nowrap;
  line-height: 1;
}
.btn:disabled { opacity: 0.5; cursor: not-allowed; }

.btn-primary {
  background: var(--accent);
  color: #fff;
}
.btn-primary:hover:not(:disabled) { background: #4f46e5; transform: translateY(-1px); }

.btn-success {
  background: var(--success);
  color: #fff;
}
.btn-success:hover:not(:disabled) { background: #059669; }

.btn-danger {
  background: transparent;
  color: var(--danger);
  border: 1px solid rgba(239,68,68,0.3);
}
.btn-danger:hover:not(:disabled) { background: rgba(239,68,68,0.12); }

.btn-ghost {
  background: transparent;
  color: var(--text-secondary);
  border: 1px solid var(--border);
}
.btn-ghost:hover:not(:disabled) { background: var(--bg-elevated); color: var(--text-primary); }

.btn-warning {
  background: rgba(245,158,11,0.15);
  color: var(--warning);
  border: 1px solid rgba(245,158,11,0.3);
}
.btn-warning:hover:not(:disabled) { background: rgba(245,158,11,0.25); }

.btn-sm { padding: 6px 12px; font-size: 0.8rem; }
.btn-lg { padding: 12px 24px; font-size: 1rem; }
.btn-full { width: 100%; justify-content: center; }
.btn-icon { padding: 8px; }

/* ─── Forms ───────────────────────────────────────────────────────────── */
.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 18px;
}
.form-group label {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.form-group input,
.form-group select,
.form-group textarea {
  background: var(--bg-base);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  color: var(--text-primary);
  padding: 10px 14px;
  font-size: 0.9rem;
  outline: none;
  transition: border-color var(--transition);
  width: 100%;
}
.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  border-color: var(--border-focus);
  box-shadow: 0 0 0 3px var(--accent-dim);
}
.form-group select option { background: var(--bg-surface); }
.form-group textarea { resize: vertical; min-height: 90px; }
.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px;
}
.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 12px;
  border-top: 1px solid var(--border);
  margin-top: 8px;
}

/* ─── Table ───────────────────────────────────────────────────────────── */
.table-wrapper { overflow-x: auto; }
.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}
.data-table th {
  text-align: left;
  padding: 12px 16px;
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--text-muted);
  background: var(--bg-base);
  border-bottom: 1px solid var(--border);
  white-space: nowrap;
}
.data-table td {
  padding: 13px 16px;
  border-bottom: 1px solid var(--border);
  color: var(--text-secondary);
  vertical-align: middle;
}
.data-table tr:last-child td { border-bottom: none; }
.data-table tbody tr { transition: background var(--transition); }
.data-table tbody tr:hover { background: var(--bg-elevated); }
.data-table td strong { color: var(--text-primary); }
.action-cell { display: flex; gap: 6px; align-items: center; }

/* ─── Badges ──────────────────────────────────────────────────────────── */
.badge {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 0.72rem;
  font-weight: 600;
  white-space: nowrap;
}
.badge--New           { background: rgba(59,130,246,0.15);  color: #60a5fa; }
.badge--Contacted     { background: rgba(139,92,246,0.15);  color: #a78bfa; }
.badge--Follow-up     { background: rgba(245,158,11,0.15);  color: #fbbf24; }
.badge--Will-Visit    { background: rgba(20,184,166,0.18);  color: #2dd4bf; }
.badge--Visited       { background: rgba(6,182,212,0.18);   color: #22d3ee; }
.badge--Converted     { background: rgba(16,185,129,0.15);  color: #34d399; }
.badge--Not-Interested{ background: rgba(239,68,68,0.15);   color: #f87171; }
.badge--admin         { background: rgba(99,102,241,0.2);   color: var(--accent-light); }
.badge--counselor     { background: rgba(6,182,212,0.15);   color: #22d3ee; }
.badge--active        { background: rgba(16,185,129,0.15);  color: #34d399; }
.badge--inactive      { background: rgba(239,68,68,0.1);    color: #f87171; }
.badge--Pending       { background: rgba(245,158,11,0.15);  color: #fbbf24; }
.badge--Done          { background: rgba(16,185,129,0.15);  color: #34d399; }
.badge--Rescheduled   { background: rgba(99,102,241,0.15);  color: #a78bfa; }

/* ─── Search / Filter ─────────────────────────────────────────────────── */
.search-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.search-input {
  background: var(--bg-base);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  color: var(--text-primary);
  padding: 9px 14px;
  font-size: 0.875rem;
  outline: none;
  min-width: 220px;
  transition: border-color var(--transition);
}
.search-input:focus { border-color: var(--border-focus); }
.filter-select {
  background: var(--bg-base);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  color: var(--text-secondary);
  padding: 9px 14px;
  font-size: 0.875rem;
  outline: none;
  cursor: pointer;
  transition: border-color var(--transition);
}
.filter-select:focus { border-color: var(--border-focus); color: var(--text-primary); }

/* ─── Pagination ──────────────────────────────────────────────────────── */
.pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  padding: 16px 22px;
  border-top: 1px solid var(--border);
  flex-wrap: wrap;
}
.pagination-btn {
  padding: 7px 14px;
  border-radius: var(--radius-sm);
  background: var(--bg-elevated);
  border: 1px solid var(--border);
  color: var(--text-secondary);
  font-size: 0.8rem;
  cursor: pointer;
  transition: all var(--transition);
}
.pagination-btn:hover:not(:disabled) { background: var(--bg-hover); color: var(--text-primary); }
.pagination-btn.active { background: var(--accent); color: #fff; border-color: var(--accent); }
.pagination-btn:disabled { opacity: 0.4; cursor: not-allowed; }
.pagination-info { font-size: 0.8rem; color: var(--text-muted); }

/* ─── Auth pages ──────────────────────────────────────────────────────── */
.auth-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: radial-gradient(ellipse at 60% 30%, rgba(99,102,241,0.15) 0%, transparent 70%),
              var(--bg-base);
  padding: 24px;
}
.auth-card {
  background: var(--bg-surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 40px;
  width: 100%;
  max-width: 420px;
  box-shadow: var(--shadow-lg);
}
.auth-logo {
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 8px;
}
.auth-title {
  font-size: 1.5rem;
  font-weight: 700;
  text-align: center;
  color: var(--text-primary);
  margin-bottom: 4px;
}
.auth-subtitle {
  text-align: center;
  color: var(--text-muted);
  font-size: 0.875rem;
  margin-bottom: 32px;
}
.auth-form .form-group { margin-bottom: 16px; }
.auth-footer {
  text-align: center;
  font-size: 0.8rem;
  color: var(--text-muted);
  margin-top: 20px;
}

/* ─── Notifications / Toast ───────────────────────────────────────────── */
.notification-bar {
  background: rgba(245,158,11,0.12);
  border: 1px solid rgba(245,158,11,0.3);
  border-radius: var(--radius);
  padding: 12px 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 22px;
  cursor: pointer;
  transition: background var(--transition);
}
.notification-bar:hover { background: rgba(245,158,11,0.18); }
.notification-bar span { color: var(--warning); font-size: 0.875rem; font-weight: 500; }

/* ─── Empty state ─────────────────────────────────────────────────────── */
.empty-state {
  text-align: center;
  padding: 48px 24px;
  color: var(--text-muted);
}
.empty-state-icon { font-size: 3rem; margin-bottom: 12px; opacity: 0.5; }
.empty-state p { font-size: 0.9rem; }

/* ─── Loading ─────────────────────────────────────────────────────────── */
.loading-center {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px;
  color: var(--text-muted);
  font-size: 0.9rem;
  gap: 10px;
}
.spinner {
  width: 20px; height: 20px;
  border: 2px solid var(--border);
  border-top-color: var(--accent);
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
  flex-shrink: 0;
}
@keyframes spin { to { transform: rotate(360deg); } }

/* ─── Timeline ────────────────────────────────────────────────────────── */
.timeline { list-style: none; position: relative; padding-left: 24px; }
.timeline::before {
  content: '';
  position: absolute;
  left: 8px; top: 0; bottom: 0;
  width: 2px;
  background: var(--border);
}
.timeline-item {
  position: relative;
  margin-bottom: 18px;
  padding-left: 16px;
}
.timeline-item::before {
  content: '';
  position: absolute;
  left: -8px;
  top: 6px;
  width: 10px; height: 10px;
  border-radius: 50%;
  background: var(--accent);
  border: 2px solid var(--bg-surface);
}
.timeline-action {
  font-size: 0.875rem;
  color: var(--text-primary);
  font-weight: 500;
}
.timeline-meta {
  font-size: 0.75rem;
  color: var(--text-muted);
  margin-top: 2px;
}

/* ─── Tabs ────────────────────────────────────────────────────────────── */
.tabs {
  display: flex;
  gap: 4px;
  border-bottom: 1px solid var(--border);
  margin-bottom: 24px;
}
.tab-btn {
  padding: 10px 18px;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  color: var(--text-muted);
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all var(--transition);
  white-space: nowrap;
}
.tab-btn:hover  { color: var(--text-secondary); }
.tab-btn.active { color: var(--accent-light); border-bottom-color: var(--accent); }

/* ─── Dashboard Grid ──────────────────────────────────────────────────── */
.dashboard-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}
.dashboard-grid .card { min-height: 300px; }

/* ─── Charts ──────────────────────────────────────────────────────────── */
.chart-card { padding: 18px 22px 22px; }
.chart-title { font-size: 0.875rem; font-weight: 600; color: var(--text-secondary); margin-bottom: 18px; }

/* ─── File Upload ─────────────────────────────────────────────────────── */
.upload-zone {
  border: 2px dashed var(--border);
  border-radius: var(--radius-lg);
  padding: 48px 32px;
  text-align: center;
  cursor: pointer;
  transition: all var(--transition);
  background: var(--bg-base);
}
.upload-zone:hover, .upload-zone.dragover {
  border-color: var(--accent);
  background: var(--accent-dim);
}
.upload-zone-icon { font-size: 3rem; margin-bottom: 12px; }
.upload-zone p.primary { color: var(--text-primary); font-weight: 600; margin-bottom: 4px; }
.upload-zone p.secondary { color: var(--text-muted); font-size: 0.8rem; }

/* ─── Import result ───────────────────────────────────────────────────── */
.import-result {
  background: var(--bg-elevated);
  border-radius: var(--radius);
  padding: 20px;
  margin-top: 20px;
}
.import-result h3 { font-size: 0.9rem; color: var(--text-primary); margin-bottom: 12px; }
.import-stat { display: flex; justify-content: space-between; color: var(--text-secondary); font-size: 0.875rem; padding: 4px 0; }
.import-errors { margin-top: 12px; }
.import-error-item { font-size: 0.8rem; color: var(--danger); padding: 3px 0; }

/* ─── Responsive ──────────────────────────────────────────────────────── */
@media (max-width: 1024px) {
  .dashboard-grid { grid-template-columns: 1fr; }
}
@media (max-width: 768px) {
  .main-content { margin-left: 0 !important; }
  .sidebar { transform: translateX(-100%); z-index: 200; }
  .sidebar.mobile-open { transform: translateX(0); }
  .page { padding: 16px; }
  .stats-grid { grid-template-columns: repeat(2, 1fr); }
  .form-row { grid-template-columns: 1fr; }
  .page-header { flex-direction: column; align-items: stretch; }
}
@media (max-width: 480px) {
  .stats-grid { grid-template-columns: 1fr; }
  .auth-card { padding: 28px 20px; }
}

/* ─── Modal ──────────────────────────────────────────────────────────── */
.modal-overlay {
  position: fixed; inset: 0; z-index: 1000;
  background: rgba(0,0,0,0.55);
  backdrop-filter: blur(4px);
  display: flex; align-items: center; justify-content: center;
  padding: 20px;
  animation: fadeIn 0.15s ease;
}
.modal {
  background: var(--bg-elevated);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  width: 100%; max-height: 90vh;
  display: flex; flex-direction: column;
  animation: scaleIn 0.18s ease;
}
@keyframes scaleIn {
  from { opacity: 0; transform: scale(0.96) translateY(8px); }
  to   { opacity: 1; transform: scale(1) translateY(0); }
}
@keyframes fadeIn {
  from { opacity: 0; } to { opacity: 1; }
}
.modal-header {
  display: flex; align-items: flex-start; justify-content: space-between;
  padding: 20px 24px 16px;
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;
}
.modal-title {
  font-size: 1.1rem; font-weight: 700; color: var(--text-primary);
  margin: 0;
}
.modal-close {
  background: none; border: none; color: var(--text-muted);
  font-size: 1.1rem; cursor: pointer; padding: 4px 8px;
  border-radius: var(--radius-sm); line-height: 1;
  transition: color 0.15s, background 0.15s;
  flex-shrink: 0; margin-left: 12px;
}
.modal-close:hover { color: var(--text-primary); background: var(--bg-hover); }
.modal-body {
  overflow-y: auto; flex: 1 1;
  padding: 20px 24px;
}
.modal-footer {
  display: flex; align-items: center; justify-content: flex-end; gap: 10px;
  padding: 14px 24px;
  border-top: 1px solid var(--border);
  flex-shrink: 0;
}

/* ─── Upload Zone ───────────────────────────────────────────────────── */
.upload-zone {
  border: 2px dashed var(--border);
  border-radius: var(--radius-lg);
  padding: 32px 20px;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s;
}
.upload-zone:hover, .upload-zone.dragover {
  border-color: var(--accent);
  background: var(--accent-dim);
}
.upload-zone-icon { font-size: 2.5rem; margin-bottom: 10px; }
.upload-zone p.primary { font-weight: 600; color: var(--text-primary); margin-bottom: 4px; }
.upload-zone p.secondary { font-size: 0.8rem; color: var(--text-muted); }

/* ─── Import Result ─────────────────────────────────────────────────── */
.import-result {
  margin-top: 20px; padding: 16px; border-radius: var(--radius);
  border: 1px solid var(--border); background: var(--bg-base);
}
.import-result h3 { font-size: 0.85rem; font-weight: 700; color: var(--text-primary); margin-bottom: 12px; }
.import-stat {
  display: flex; justify-content: space-between;
  font-size: 0.83rem; color: var(--text-muted);
  padding: 6px 0; border-bottom: 1px solid var(--border);
}
.import-errors { margin-top: 10px; }
.import-error-item { font-size: 0.75rem; color: var(--danger); padding: 2px 0; }

/* ─── Misc badge ────────────────────────────────────────────────────── */
.badge--danger { background: rgba(239,68,68,.12); color: #ef4444; }
.badge--followup { background: rgba(245,158,11,.12); color: #f59e0b; }

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA,2EAA2E;AAC3E;EACE,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;;EAEvB,uBAAuB;EACvB,uBAAuB;EACvB,qCAAqC;;EAErC,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;;EAEvB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;;EAEzB,sCAAsC;EACtC,oCAAoC;;EAEpC,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;;EAElB,sCAAsC;EACtC,uCAAuC;EACvC,uCAAuC;;EAEvC,kBAAkB;EAClB,2BAA2B;;EAE3B,uBAAuB;AACzB;;AAEA,2EAA2E;AAC3E;EACE,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;;EAEvB,uBAAuB;EACvB,uBAAuB;EACvB,qCAAqC;;EAErC,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;;EAEvB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;;EAEzB,gCAAgC;EAChC,oCAAoC;;EAEpC,uCAAuC;EACvC,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA,kDAAkD;AAClD,wCAAwC,mBAAmB,EAAE,wCAAwC,EAAE;AACvG,wCAAwC,cAAc,EAAE;AACxD,wCAAwC,cAAc,EAAE;AACxD,wCAAwC,iCAAiC,EAAE,cAAc,EAAE;AAC3F,wCAAwC,iCAAiC,EAAE,cAAc,EAAE;AAC3F,0CAA0C,cAAc,EAAE;AAC1D,wCAAwC,mBAAmB,EAAE,yCAAyC,EAAE,sCAAsC,EAAE;AAChJ,wCAAwC,mBAAmB,EAAE;AAC7D,8CAA8C,mBAAmB,EAAE;AACnE;;wCAEwC,gBAAgB,EAAE,8BAA8B,EAAE,cAAc,EAAE;AAC1G;yCACyC,cAAc,EAAE;AACzD,wCAAwC,mBAAmB,EAAE,8BAA8B,EAAE;AAC7F,wCAAwC,mBAAmB,EAAE,qCAAqC,EAAE;AACpG,wCAAwC,mBAAmB,EAAE;AAC7D,wCAAwC,mBAAmB,EAAE;AAC7D,wCAAwC,4BAA4B,EAAE;;;AAGtE,4EAA4E;AAC5E,yBAAyB,sBAAsB,EAAE,SAAS,EAAE,UAAU,EAAE;;AAExE,OAAO,eAAe,EAAE,uBAAuB,EAAE;;AAEjD;EACE,mEAAmE;EACnE,0BAA0B;EAC1B,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA,IAAI,0BAA0B,EAAE,qBAAqB,EAAE;AACvD,UAAU,oBAAoB,EAAE;AAChC,kCAAkC,oBAAoB,EAAE;AACxD,MAAM,eAAe,EAAE;;AAEvB,4EAA4E;AAC5E,4BAA4B,UAAU,EAAE,WAAW,EAAE;AACrD,4BAA4B,uBAAuB,EAAE;AACrD,4BAA4B,8BAA8B,EAAE,kBAAkB,EAAE;;AAEhF,4EAA4E;AAC5E;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,6BAA6B;EAC7B,iBAAiB;EACjB,iBAAiB,EAAE,kBAAkB;EACrC,yCAAyC;EACzC,0BAA0B;AAC5B;AACA,kCAAkC,uCAAuC,EAAE;;AAE3E,6EAA6E;AAC7E;EACE,eAAe;EACf,MAAM;EACN,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,6BAA6B;EAC7B,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,SAAS;EACT,YAAY;EACZ,gEAAgE;EAChE,4BAA4B;AAC9B;AACA,gCAAgC,gCAAgC,EAAE;;AAElE;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,8BAA8B;EAC9B,+BAA+B;EAC/B,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,0BAA0B;EAC1B,2BAA2B;EAC3B,0CAA0C;AAC5C;AACA,iCAAiC,eAAe,EAAE,cAAc,EAAE,+BAA+B,EAAE;AACnG,uCAAuC,wBAAwB,EAAE;;AAEjE,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,qCAAqC;EACrC,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B;EAChE,cAAc;AAChB;;AAEA,4EAA4E;AAC5E;EACE,eAAe;EACf,MAAM,EAAE,OAAO;EACf,uBAAuB;EACvB,aAAa;EACb,6BAA6B;EAC7B,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mCAAmC;EACnC,gBAAgB;AAClB;AACA,qBAAqB,iCAAiC,EAAE;;AAExD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uEAAuE;EACvE,6BAA6B;EAC7B,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,cAAc;EACd,cAAc;EACd,iEAAiE;AACnE;AACA,wBAAwB,0BAA0B,EAAE,8BAA8B,EAAE;;AAEpF;EACE,SAAO;EACP,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;EACjC,kBAAkB;EAClB,kBAAkB;AACpB;AACA,sBAAsB,0BAA0B,EAAE,8BAA8B,EAAE;AAClF;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO,EAAE,QAAQ,EAAE,WAAW;EAC9B,UAAU;EACV,yBAAyB;EACzB,0BAA0B;AAC5B;AACA,gBAAgB,iBAAiB,EAAE,cAAc,EAAE;AACnD,iBAAiB,gBAAgB,EAAE;;AAEnC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mCAAmC;EACnC,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,2DAA2D;EAC3D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;AACA,aAAa,gBAAgB,EAAE;AAC/B;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;AAClB;AACA,oBAAoB,oBAAoB,EAAE,+BAA+B,EAAE;;AAE3E,4EAA4E;AAC5E;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;AACjB;AACA,gBAAgB,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE,mBAAmB,EAAE;;AAEhF,4EAA4E;AAC5E;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,sCAAsC;EACtC,SAAS;EACT,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA,aAAa,aAAa,EAAE;;AAE5B,4EAA4E;AAC5E;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qEAAqE;EACrE,eAAe;AACjB;AACA,mBAAmB,2BAA2B,EAAE,yBAAyB,EAAE;AAC3E;EACE,WAAW,EAAE,YAAY;EACzB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;EACd,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,cAAc;AAChB;AACA,gCAAgC,iCAAiC,GAAG,cAAc,EAAE;AACpF,gCAAgC,iCAAiC,GAAG,cAAc,EAAE;AACpF,gCAAgC,iCAAiC,GAAG,cAAc,EAAE;AACpF,gCAAgC,iCAAiC,GAAG,cAAc,EAAE;AACpF,gCAAgC,gCAAgC,IAAI,cAAc,EAAE;AACpF,gCAAgC,gCAAgC,IAAI,cAAc,EAAE;;AAEpF,4EAA4E;AAC5E;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,iBAAiB;EACjB,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,iCAAiC;EACjC,mBAAmB;EACnB,cAAc;AAChB;AACA,gBAAgB,YAAY,EAAE,mBAAmB,EAAE;;AAEnD;EACE,yBAAyB;EACzB,WAAW;AACb;AACA,oCAAoC,mBAAmB,EAAE,2BAA2B,EAAE;;AAEtF;EACE,0BAA0B;EAC1B,WAAW;AACb;AACA,oCAAoC,mBAAmB,EAAE;;AAEzD;EACE,uBAAuB;EACvB,oBAAoB;EACpB,qCAAqC;AACvC;AACA,mCAAmC,gCAAgC,EAAE;;AAErE;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,+BAA+B;AACjC;AACA,kCAAkC,8BAA8B,EAAE,0BAA0B,EAAE;;AAE9F;EACE,iCAAiC;EACjC,qBAAqB;EACrB,sCAAsC;AACxC;AACA,oCAAoC,iCAAiC,EAAE;;AAEvE,UAAU,iBAAiB,EAAE,iBAAiB,EAAE;AAChD,UAAU,kBAAkB,EAAE,eAAe,EAAE;AAC/C,YAAY,WAAW,EAAE,uBAAuB,EAAE;AAClD,YAAY,YAAY,EAAE;;AAE1B,4EAA4E;AAC5E;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;AACxB;AACA;;;EAGE,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,0BAA0B;EAC1B,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,0CAA0C;EAC1C,WAAW;AACb;AACA;;;EAGE,iCAAiC;EACjC,uCAAuC;AACzC;AACA,4BAA4B,6BAA6B,EAAE;AAC3D,uBAAuB,gBAAgB,EAAE,gBAAgB,EAAE;AAC3D;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,mCAAmC;EACnC,eAAe;AACjB;;AAEA,4EAA4E;AAC5E,iBAAiB,gBAAgB,EAAE;AACnC;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,0BAA0B;EAC1B,sCAAsC;EACtC,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,4BAA4B;EAC5B,sBAAsB;AACxB;AACA,+BAA+B,mBAAmB,EAAE;AACpD,uBAAuB,wCAAwC,EAAE;AACjE,6BAA6B,8BAA8B,EAAE;AAC7D,wBAAwB,0BAA0B,EAAE;AACpD,eAAe,aAAa,EAAE,QAAQ,EAAE,mBAAmB,EAAE;;AAE7D,4EAA4E;AAC5E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA,wBAAwB,iCAAiC,GAAG,cAAc,EAAE;AAC5E,wBAAwB,iCAAiC,GAAG,cAAc,EAAE;AAC5E,wBAAwB,iCAAiC,GAAG,cAAc,EAAE;AAC5E,wBAAwB,iCAAiC,GAAG,cAAc,EAAE;AAC5E,wBAAwB,gCAAgC,IAAI,cAAc,EAAE;AAC5E,wBAAwB,iCAAiC,GAAG,cAAc,EAAE;AAC5E,wBAAwB,gCAAgC,IAAI,cAAc,EAAE;AAC5E,wBAAwB,gCAAgC,IAAI,0BAA0B,EAAE;AACxF,wBAAwB,gCAAgC,IAAI,cAAc,EAAE;AAC5E,wBAAwB,iCAAiC,GAAG,cAAc,EAAE;AAC5E,wBAAwB,+BAA+B,KAAK,cAAc,EAAE;AAC5E,wBAAwB,iCAAiC,GAAG,cAAc,EAAE;AAC5E,wBAAwB,iCAAiC,GAAG,cAAc,EAAE;AAC5E,wBAAwB,iCAAiC,GAAG,cAAc,EAAE;;AAE5E,4EAA4E;AAC5E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,0CAA0C;AAC5C;AACA,sBAAsB,iCAAiC,EAAE;AACzD;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,4BAA4B;EAC5B,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,0CAA0C;AAC5C;AACA,uBAAuB,iCAAiC,EAAE,0BAA0B,EAAE;;AAEtF,4EAA4E;AAC5E;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,8BAA8B;EAC9B,+BAA+B;EAC/B,4BAA4B;EAC5B,iBAAiB;EACjB,eAAe;EACf,iCAAiC;AACnC;AACA,uCAAuC,2BAA2B,EAAE,0BAA0B,EAAE;AAChG,yBAAyB,yBAAyB,EAAE,WAAW,EAAE,2BAA2B,EAAE;AAC9F,2BAA2B,YAAY,EAAE,mBAAmB,EAAE;AAC9D,mBAAmB,iBAAiB,EAAE,wBAAwB,EAAE;;AAEhE,4EAA4E;AAC5E;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;4BAC0B;EAC1B,aAAa;AACf;AACA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;AACrB;AACA,yBAAyB,mBAAmB,EAAE;AAC9C;EACE,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,4EAA4E;AAC5E;EACE,iCAAiC;EACjC,sCAAsC;EACtC,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,wCAAwC;AAC1C;AACA,0BAA0B,iCAAiC,EAAE;AAC7D,yBAAyB,qBAAqB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;;AAEvF,4EAA4E;AAC5E;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;AACA,oBAAoB,eAAe,EAAE,mBAAmB,EAAE,YAAY,EAAE;AACxE,iBAAiB,iBAAiB,EAAE;;AAEpC,4EAA4E;AAC5E;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,wBAAwB;EACxB,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,WAAW,EAAE,YAAY;EACzB,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;AAChB;AACA,kBAAkB,KAAK,yBAAyB,EAAE,EAAE;;AAEpD,4EAA4E;AAC5E,YAAY,gBAAgB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE;AACtE;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS,EAAE,MAAM,EAAE,SAAS;EAC5B,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,mCAAmC;AACrC;AACA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;AACjB;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,QAAQ;EACR,sCAAsC;EACtC,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,mBAAmB;AACrB;AACA,kBAAkB,4BAA4B,EAAE;AAChD,kBAAkB,0BAA0B,EAAE,kCAAkC,EAAE;;AAElF,4EAA4E;AAC5E;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA,wBAAwB,iBAAiB,EAAE;;AAE3C,4EAA4E;AAC5E,cAAc,uBAAuB,EAAE;AACvC,eAAe,mBAAmB,EAAE,gBAAgB,EAAE,4BAA4B,EAAE,mBAAmB,EAAE;;AAEzG,4EAA4E;AAC5E;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,0BAA0B;AAC5B;AACA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA,oBAAoB,eAAe,EAAE,mBAAmB,EAAE;AAC1D,yBAAyB,0BAA0B,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AAC3F,2BAA2B,wBAAwB,EAAE,iBAAiB,EAAE;;AAExE,4EAA4E;AAC5E;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;AAClB;AACA,oBAAoB,iBAAiB,EAAE,0BAA0B,EAAE,mBAAmB,EAAE;AACxF,eAAe,aAAa,EAAE,8BAA8B,EAAE,4BAA4B,EAAE,mBAAmB,EAAE,cAAc,EAAE;AACjI,iBAAiB,gBAAgB,EAAE;AACnC,qBAAqB,iBAAiB,EAAE,oBAAoB,EAAE,cAAc,EAAE;;AAE9E,4EAA4E;AAC5E;EACE,kBAAkB,0BAA0B,EAAE;AAChD;AACA;EACE,gBAAgB,yBAAyB,EAAE;EAC3C,WAAW,4BAA4B,EAAE,YAAY,EAAE;EACvD,uBAAuB,wBAAwB,EAAE;EACjD,QAAQ,aAAa,EAAE;EACvB,cAAc,qCAAqC,EAAE;EACrD,YAAY,0BAA0B,EAAE;EACxC,eAAe,sBAAsB,EAAE,oBAAoB,EAAE;AAC/D;AACA;EACE,cAAc,0BAA0B,EAAE;EAC1C,aAAa,kBAAkB,EAAE;AACnC;;AAEA,2EAA2E;AAC3E;EACE,eAAe,EAAE,QAAQ,EAAE,aAAa;EACxC,4BAA4B;EAC5B,0BAA0B;EAC1B,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,aAAa;EACb,4BAA4B;AAC9B;AACA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,WAAW,EAAE,gBAAgB;EAC7B,aAAa,EAAE,sBAAsB;EACrC,6BAA6B;AAC/B;AACA;EACE,OAAO,UAAU,EAAE,sCAAsC,EAAE;EAC3D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;AACA;EACE,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE;AACxC;AACA;EACE,aAAa,EAAE,uBAAuB,EAAE,8BAA8B;EACtE,uBAAuB;EACvB,sCAAsC;EACtC,cAAc;AAChB;AACA;EACE,iBAAiB,EAAE,gBAAgB,EAAE,0BAA0B;EAC/D,SAAS;AACX;AACA;EACE,gBAAgB,EAAE,YAAY,EAAE,wBAAwB;EACxD,iBAAiB,EAAE,eAAe,EAAE,gBAAgB;EACpD,+BAA+B,EAAE,cAAc;EAC/C,yCAAyC;EACzC,cAAc,EAAE,iBAAiB;AACnC;AACA,qBAAqB,0BAA0B,EAAE,2BAA2B,EAAE;AAC9E;EACE,gBAAgB,EAAE,SAAO;EACzB,kBAAkB;AACpB;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,yBAAyB,EAAE,SAAS;EACxE,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;AAChB;;AAEA,0EAA0E;AAC1E;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,8CAA8C;AAChD;AACA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA,oBAAoB,iBAAiB,EAAE,mBAAmB,EAAE;AAC5D,yBAAyB,gBAAgB,EAAE,0BAA0B,EAAE,kBAAkB,EAAE;AAC3F,2BAA2B,iBAAiB,EAAE,wBAAwB,EAAE;;AAExE,0EAA0E;AAC1E;EACE,gBAAgB,EAAE,aAAa,EAAE,4BAA4B;EAC7D,+BAA+B,EAAE,0BAA0B;AAC7D;AACA,oBAAoB,kBAAkB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,mBAAmB,EAAE;AAC3G;EACE,aAAa,EAAE,8BAA8B;EAC7C,kBAAkB,EAAE,wBAAwB;EAC5C,cAAc,EAAE,sCAAsC;AACxD;AACA,iBAAiB,gBAAgB,EAAE;AACnC,qBAAqB,kBAAkB,EAAE,oBAAoB,EAAE,cAAc,EAAE;;AAE/E,0EAA0E;AAC1E,iBAAiB,+BAA+B,EAAE,cAAc,EAAE;AAClE,mBAAmB,gCAAgC,EAAE,cAAc,EAAE","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');\n\n/* ─── CSS Variables — Dark Theme (default) ───────────────────────────── */\n:root {\n  --bg-base:      #0f1117;\n  --bg-surface:   #1a1d27;\n  --bg-elevated:  #22263a;\n  --bg-hover:     #2a2f47;\n\n  --accent:       #6366f1;\n  --accent-light: #818cf8;\n  --accent-dim:   rgba(99,102,241,0.15);\n\n  --success:      #10b981;\n  --warning:      #f59e0b;\n  --danger:       #ef4444;\n  --info:         #3b82f6;\n\n  --text-primary:   #f1f5f9;\n  --text-secondary: #94a3b8;\n  --text-muted:     #64748b;\n\n  --border:       rgba(255,255,255,0.07);\n  --border-focus: rgba(99,102,241,0.5);\n\n  --radius-sm:  6px;\n  --radius:     10px;\n  --radius-lg:  16px;\n\n  --shadow-sm: 0 1px 3px rgba(0,0,0,0.4);\n  --shadow:    0 4px 20px rgba(0,0,0,0.5);\n  --shadow-lg: 0 8px 40px rgba(0,0,0,0.6);\n\n  --sidebar-w: 240px;\n  --sidebar-w-collapsed: 68px;\n\n  --transition: 0.2s ease;\n}\n\n/* ─── CSS Variables — Light Theme ────────────────────────────────────── */\nbody.light-theme {\n  --bg-base:      #f0f2f8;\n  --bg-surface:   #ffffff;\n  --bg-elevated:  #f8f9fc;\n  --bg-hover:     #e8eaf2;\n\n  --accent:       #6366f1;\n  --accent-light: #4f46e5;\n  --accent-dim:   rgba(99,102,241,0.10);\n\n  --success:      #059669;\n  --warning:      #d97706;\n  --danger:       #dc2626;\n  --info:         #2563eb;\n\n  --text-primary:   #0f172a;\n  --text-secondary: #475569;\n  --text-muted:     #94a3b8;\n\n  --border:       rgba(0,0,0,0.08);\n  --border-focus: rgba(99,102,241,0.4);\n\n  --shadow-sm: 0 1px 3px rgba(0,0,0,0.08);\n  --shadow:    0 4px 20px rgba(0,0,0,0.10);\n  --shadow-lg: 0 8px 40px rgba(0,0,0,0.14);\n}\n\n/* Light theme overrides for specific components */\nbody.light-theme .sidebar             { background: #ffffff; border-right: 1px solid rgba(0,0,0,0.08); }\nbody.light-theme .sidebar-logo        { color: #4f46e5; }\nbody.light-theme .sidebar-link        { color: #475569; }\nbody.light-theme .sidebar-link:hover  { background: rgba(99,102,241,0.08); color: #4f46e5; }\nbody.light-theme .sidebar-link.active { background: rgba(99,102,241,0.12); color: #4f46e5; }\nbody.light-theme .sidebar-section-title { color: #94a3b8; }\nbody.light-theme .app-header          { background: #ffffff; border-bottom: 1px solid rgba(0,0,0,0.08); box-shadow: 0 1px 8px rgba(0,0,0,0.06); }\nbody.light-theme .data-table thead tr { background: #f1f3f9; }\nbody.light-theme .data-table tbody tr:hover { background: #f5f7ff; }\nbody.light-theme input,\nbody.light-theme select,\nbody.light-theme textarea             { background: #fff; border-color: rgba(0,0,0,0.12); color: #0f172a; }\nbody.light-theme input::placeholder,\nbody.light-theme textarea::placeholder { color: #94a3b8; }\nbody.light-theme .card                { background: #ffffff; border-color: rgba(0,0,0,0.07); }\nbody.light-theme .card-header         { background: #f8f9fc; border-bottom-color: rgba(0,0,0,0.07); }\nbody.light-theme .modal               { background: #ffffff; }\nbody.light-theme .modal-header        { background: #f8f9fc; }\nbody.light-theme .theme-toggle-btn    { background: rgba(0,0,0,0.05); }\n\n\n/* ─── Reset ───────────────────────────────────────────────────────────── */\n*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }\n\nhtml { font-size: 15px; scroll-behavior: smooth; }\n\nbody {\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;\n  background: var(--bg-base);\n  color: var(--text-primary);\n  line-height: 1.6;\n  min-height: 100vh;\n  -webkit-font-smoothing: antialiased;\n}\n\na { color: var(--accent-light); text-decoration: none; }\na:hover { color: var(--accent); }\ninput, select, textarea, button { font-family: inherit; }\nimg { max-width: 100%; }\n\n/* ─── Scrollbar ───────────────────────────────────────────────────────── */\n::-webkit-scrollbar       { width: 6px; height: 6px; }\n::-webkit-scrollbar-track { background: transparent; }\n::-webkit-scrollbar-thumb { background: var(--bg-elevated); border-radius: 3px; }\n\n/* ─── Layout ──────────────────────────────────────────────────────────── */\n.app-layout {\n  display: flex;\n  min-height: 100vh;\n}\n\n.main-content {\n  flex: 1;\n  margin-left: var(--sidebar-w);\n  min-height: 100vh;\n  padding-top: 56px; /* header height */\n  transition: margin-left var(--transition);\n  background: var(--bg-base);\n}\n.main-content.sidebar-collapsed { margin-left: var(--sidebar-w-collapsed); }\n\n/* ─── App Header Bar ───────────────────────────────────────────────────── */\n.app-header {\n  position: fixed;\n  top: 0;\n  left: var(--sidebar-w);\n  right: 0;\n  height: 56px;\n  background: var(--bg-surface);\n  border-bottom: 1px solid var(--border);\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 0 24px;\n  gap: 12px;\n  z-index: 100;\n  transition: left var(--transition), background var(--transition);\n  box-shadow: var(--shadow-sm);\n}\n.app-header.sidebar-collapsed { left: var(--sidebar-w-collapsed); }\n\n.header-page-title {\n  flex: 1;\n  font-size: 0.88rem;\n  font-weight: 600;\n  color: var(--text-muted);\n  letter-spacing: 0.02em;\n}\n\n/* Theme toggle button */\n.theme-toggle-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 16px;\n  background: var(--bg-elevated);\n  border: 1px solid var(--border);\n  border-radius: 50px;\n  color: var(--text-secondary);\n  font-size: 0.82rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.25s ease;\n  white-space: nowrap;\n  outline: none;\n  user-select: none;\n}\n.theme-toggle-btn:hover {\n  background: var(--accent-dim);\n  border-color: var(--border-focus);\n  color: var(--accent-light);\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(99,102,241,0.2);\n}\n.theme-toggle-btn .toggle-icon { font-size: 1rem; line-height: 1; transition: transform 0.4s ease; }\n.theme-toggle-btn:hover .toggle-icon { transform: rotate(20deg); }\n\n/* Header user info */\n.header-user {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--text-secondary);\n  font-size: 0.82rem;\n}\n.header-user-avatar {\n  width: 30px; height: 30px;\n  border-radius: 50%;\n  background: var(--accent-dim);\n  border: 1px solid var(--border-focus);\n  display: flex; align-items: center; justify-content: center;\n  font-size: 0.78rem; font-weight: 700; color: var(--accent-light);\n  flex-shrink: 0;\n}\n\n/* ─── Sidebar ─────────────────────────────────────────────────────────── */\n.sidebar {\n  position: fixed;\n  top: 0; left: 0;\n  width: var(--sidebar-w);\n  height: 100vh;\n  background: var(--bg-surface);\n  border-right: 1px solid var(--border);\n  display: flex;\n  flex-direction: column;\n  z-index: 100;\n  transition: width var(--transition);\n  overflow: hidden;\n}\n.sidebar.collapsed { width: var(--sidebar-w-collapsed); }\n\n.sidebar-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 16px;\n  border-bottom: 1px solid var(--border);\n  min-height: 68px;\n  flex-shrink: 0;\n}\n.sidebar-logo {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 1.05rem;\n  font-weight: 700;\n  background: linear-gradient(135deg, var(--accent), var(--accent-light));\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  white-space: nowrap;\n}\n.sidebar-logo .logo-icon {\n  font-size: 1.5rem;\n  -webkit-text-fill-color: initial;\n}\n.sidebar-toggle {\n  background: none;\n  border: none;\n  color: var(--text-muted);\n  cursor: pointer;\n  padding: 6px;\n  border-radius: var(--radius-sm);\n  font-size: 1rem;\n  line-height: 1;\n  flex-shrink: 0;\n  transition: color var(--transition), background var(--transition);\n}\n.sidebar-toggle:hover { color: var(--text-primary); background: var(--bg-elevated); }\n\n.sidebar-nav {\n  flex: 1;\n  padding: 12px 8px;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n.sidebar-link {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 12px;\n  border-radius: var(--radius);\n  color: var(--text-secondary);\n  font-size: 0.875rem;\n  font-weight: 500;\n  white-space: nowrap;\n  transition: all var(--transition);\n  margin-bottom: 2px;\n  position: relative;\n}\n.sidebar-link:hover { color: var(--text-primary); background: var(--bg-elevated); }\n.sidebar-link.active {\n  color: var(--accent-light);\n  background: var(--accent-dim);\n}\n.sidebar-link.active::before {\n  content: '';\n  position: absolute;\n  left: 0; top: 20%; bottom: 20%;\n  width: 3px;\n  background: var(--accent);\n  border-radius: 0 2px 2px 0;\n}\n.sidebar-icon { font-size: 1.1rem; flex-shrink: 0; }\n.sidebar-label { overflow: hidden; }\n\n.sidebar-section-title {\n  font-size: 0.65rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: var(--text-muted);\n  padding: 12px 12px 4px;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.sidebar-footer {\n  padding: 12px 8px;\n  border-top: 1px solid var(--border);\n  flex-shrink: 0;\n}\n.sidebar-user {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 10px;\n  border-radius: var(--radius);\n  margin-bottom: 4px;\n}\n.user-avatar-sm {\n  width: 34px; height: 34px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, var(--accent), #a78bfa);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: #fff;\n  flex-shrink: 0;\n}\n.user-info { overflow: hidden; }\n.user-info .user-name {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.user-info .user-role {\n  font-size: 0.7rem;\n  color: var(--text-muted);\n  text-transform: capitalize;\n}\n.logout-btn {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 9px 12px;\n  background: none;\n  border: none;\n  border-radius: var(--radius);\n  color: var(--text-secondary);\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all var(--transition);\n  white-space: nowrap;\n  overflow: hidden;\n}\n.logout-btn:hover { color: var(--danger); background: rgba(239,68,68,0.1); }\n\n/* ─── Page layout ─────────────────────────────────────────────────────── */\n.page {\n  padding: 28px 32px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n.page-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-bottom: 28px;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n.page-title {\n  font-size: 1.6rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  line-height: 1.2;\n}\n.page-subtitle {\n  font-size: 0.875rem;\n  color: var(--text-muted);\n  margin-top: 4px;\n}\n.page-actions { display: flex; gap: 10px; flex-wrap: wrap; align-items: center; }\n\n/* ─── Cards ───────────────────────────────────────────────────────────── */\n.card {\n  background: var(--bg-surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n}\n.card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 18px 22px;\n  border-bottom: 1px solid var(--border);\n  gap: 12px;\n  flex-wrap: wrap;\n}\n.card-title {\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n.card-body { padding: 22px; }\n\n/* ─── Stat Cards ──────────────────────────────────────────────────────── */\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));\n  gap: 16px;\n  margin-bottom: 28px;\n}\n.stat-card {\n  background: var(--bg-surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 20px 22px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  transition: transform var(--transition), box-shadow var(--transition);\n  cursor: default;\n}\n.stat-card:hover { transform: translateY(-2px); box-shadow: var(--shadow); }\n.stat-icon {\n  width: 48px; height: 48px;\n  border-radius: var(--radius);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.4rem;\n  flex-shrink: 0;\n}\n.stat-value {\n  font-size: 1.7rem;\n  font-weight: 800;\n  color: var(--text-primary);\n  line-height: 1;\n  display: block;\n}\n.stat-label {\n  font-size: 0.75rem;\n  color: var(--text-muted);\n  margin-top: 4px;\n  display: block;\n}\n.stat-card--blue   .stat-icon { background: rgba(59,130,246,0.15);  color: #3b82f6; }\n.stat-card--green  .stat-icon { background: rgba(16,185,129,0.15);  color: #10b981; }\n.stat-card--purple .stat-icon { background: rgba(139,92,246,0.15);  color: #8b5cf6; }\n.stat-card--orange .stat-icon { background: rgba(245,158,11,0.15);  color: #f59e0b; }\n.stat-card--red    .stat-icon { background: rgba(239,68,68,0.15);   color: #ef4444; }\n.stat-card--cyan   .stat-icon { background: rgba(6,182,212,0.15);   color: #06b6d4; }\n\n/* ─── Buttons ─────────────────────────────────────────────────────────── */\n.btn {\n  display: inline-flex; align-items: center; gap: 7px;\n  padding: 9px 18px;\n  border-radius: var(--radius);\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  border: none;\n  transition: all var(--transition);\n  white-space: nowrap;\n  line-height: 1;\n}\n.btn:disabled { opacity: 0.5; cursor: not-allowed; }\n\n.btn-primary {\n  background: var(--accent);\n  color: #fff;\n}\n.btn-primary:hover:not(:disabled) { background: #4f46e5; transform: translateY(-1px); }\n\n.btn-success {\n  background: var(--success);\n  color: #fff;\n}\n.btn-success:hover:not(:disabled) { background: #059669; }\n\n.btn-danger {\n  background: transparent;\n  color: var(--danger);\n  border: 1px solid rgba(239,68,68,0.3);\n}\n.btn-danger:hover:not(:disabled) { background: rgba(239,68,68,0.12); }\n\n.btn-ghost {\n  background: transparent;\n  color: var(--text-secondary);\n  border: 1px solid var(--border);\n}\n.btn-ghost:hover:not(:disabled) { background: var(--bg-elevated); color: var(--text-primary); }\n\n.btn-warning {\n  background: rgba(245,158,11,0.15);\n  color: var(--warning);\n  border: 1px solid rgba(245,158,11,0.3);\n}\n.btn-warning:hover:not(:disabled) { background: rgba(245,158,11,0.25); }\n\n.btn-sm { padding: 6px 12px; font-size: 0.8rem; }\n.btn-lg { padding: 12px 24px; font-size: 1rem; }\n.btn-full { width: 100%; justify-content: center; }\n.btn-icon { padding: 8px; }\n\n/* ─── Forms ───────────────────────────────────────────────────────────── */\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: 18px;\n}\n.form-group label {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n.form-group input,\n.form-group select,\n.form-group textarea {\n  background: var(--bg-base);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  color: var(--text-primary);\n  padding: 10px 14px;\n  font-size: 0.9rem;\n  outline: none;\n  transition: border-color var(--transition);\n  width: 100%;\n}\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  border-color: var(--border-focus);\n  box-shadow: 0 0 0 3px var(--accent-dim);\n}\n.form-group select option { background: var(--bg-surface); }\n.form-group textarea { resize: vertical; min-height: 90px; }\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 18px;\n}\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding-top: 12px;\n  border-top: 1px solid var(--border);\n  margin-top: 8px;\n}\n\n/* ─── Table ───────────────────────────────────────────────────────────── */\n.table-wrapper { overflow-x: auto; }\n.data-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n}\n.data-table th {\n  text-align: left;\n  padding: 12px 16px;\n  font-size: 0.72rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--text-muted);\n  background: var(--bg-base);\n  border-bottom: 1px solid var(--border);\n  white-space: nowrap;\n}\n.data-table td {\n  padding: 13px 16px;\n  border-bottom: 1px solid var(--border);\n  color: var(--text-secondary);\n  vertical-align: middle;\n}\n.data-table tr:last-child td { border-bottom: none; }\n.data-table tbody tr { transition: background var(--transition); }\n.data-table tbody tr:hover { background: var(--bg-elevated); }\n.data-table td strong { color: var(--text-primary); }\n.action-cell { display: flex; gap: 6px; align-items: center; }\n\n/* ─── Badges ──────────────────────────────────────────────────────────── */\n.badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 10px;\n  border-radius: 20px;\n  font-size: 0.72rem;\n  font-weight: 600;\n  white-space: nowrap;\n}\n.badge--New           { background: rgba(59,130,246,0.15);  color: #60a5fa; }\n.badge--Contacted     { background: rgba(139,92,246,0.15);  color: #a78bfa; }\n.badge--Follow-up     { background: rgba(245,158,11,0.15);  color: #fbbf24; }\n.badge--Will-Visit    { background: rgba(20,184,166,0.18);  color: #2dd4bf; }\n.badge--Visited       { background: rgba(6,182,212,0.18);   color: #22d3ee; }\n.badge--Converted     { background: rgba(16,185,129,0.15);  color: #34d399; }\n.badge--Not-Interested{ background: rgba(239,68,68,0.15);   color: #f87171; }\n.badge--admin         { background: rgba(99,102,241,0.2);   color: var(--accent-light); }\n.badge--counselor     { background: rgba(6,182,212,0.15);   color: #22d3ee; }\n.badge--active        { background: rgba(16,185,129,0.15);  color: #34d399; }\n.badge--inactive      { background: rgba(239,68,68,0.1);    color: #f87171; }\n.badge--Pending       { background: rgba(245,158,11,0.15);  color: #fbbf24; }\n.badge--Done          { background: rgba(16,185,129,0.15);  color: #34d399; }\n.badge--Rescheduled   { background: rgba(99,102,241,0.15);  color: #a78bfa; }\n\n/* ─── Search / Filter ─────────────────────────────────────────────────── */\n.search-bar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n.search-input {\n  background: var(--bg-base);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  color: var(--text-primary);\n  padding: 9px 14px;\n  font-size: 0.875rem;\n  outline: none;\n  min-width: 220px;\n  transition: border-color var(--transition);\n}\n.search-input:focus { border-color: var(--border-focus); }\n.filter-select {\n  background: var(--bg-base);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  color: var(--text-secondary);\n  padding: 9px 14px;\n  font-size: 0.875rem;\n  outline: none;\n  cursor: pointer;\n  transition: border-color var(--transition);\n}\n.filter-select:focus { border-color: var(--border-focus); color: var(--text-primary); }\n\n/* ─── Pagination ──────────────────────────────────────────────────────── */\n.pagination {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 6px;\n  padding: 16px 22px;\n  border-top: 1px solid var(--border);\n  flex-wrap: wrap;\n}\n.pagination-btn {\n  padding: 7px 14px;\n  border-radius: var(--radius-sm);\n  background: var(--bg-elevated);\n  border: 1px solid var(--border);\n  color: var(--text-secondary);\n  font-size: 0.8rem;\n  cursor: pointer;\n  transition: all var(--transition);\n}\n.pagination-btn:hover:not(:disabled) { background: var(--bg-hover); color: var(--text-primary); }\n.pagination-btn.active { background: var(--accent); color: #fff; border-color: var(--accent); }\n.pagination-btn:disabled { opacity: 0.4; cursor: not-allowed; }\n.pagination-info { font-size: 0.8rem; color: var(--text-muted); }\n\n/* ─── Auth pages ──────────────────────────────────────────────────────── */\n.auth-page {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: radial-gradient(ellipse at 60% 30%, rgba(99,102,241,0.15) 0%, transparent 70%),\n              var(--bg-base);\n  padding: 24px;\n}\n.auth-card {\n  background: var(--bg-surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 40px;\n  width: 100%;\n  max-width: 420px;\n  box-shadow: var(--shadow-lg);\n}\n.auth-logo {\n  font-size: 2.5rem;\n  text-align: center;\n  margin-bottom: 8px;\n}\n.auth-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  text-align: center;\n  color: var(--text-primary);\n  margin-bottom: 4px;\n}\n.auth-subtitle {\n  text-align: center;\n  color: var(--text-muted);\n  font-size: 0.875rem;\n  margin-bottom: 32px;\n}\n.auth-form .form-group { margin-bottom: 16px; }\n.auth-footer {\n  text-align: center;\n  font-size: 0.8rem;\n  color: var(--text-muted);\n  margin-top: 20px;\n}\n\n/* ─── Notifications / Toast ───────────────────────────────────────────── */\n.notification-bar {\n  background: rgba(245,158,11,0.12);\n  border: 1px solid rgba(245,158,11,0.3);\n  border-radius: var(--radius);\n  padding: 12px 18px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 22px;\n  cursor: pointer;\n  transition: background var(--transition);\n}\n.notification-bar:hover { background: rgba(245,158,11,0.18); }\n.notification-bar span { color: var(--warning); font-size: 0.875rem; font-weight: 500; }\n\n/* ─── Empty state ─────────────────────────────────────────────────────── */\n.empty-state {\n  text-align: center;\n  padding: 48px 24px;\n  color: var(--text-muted);\n}\n.empty-state-icon { font-size: 3rem; margin-bottom: 12px; opacity: 0.5; }\n.empty-state p { font-size: 0.9rem; }\n\n/* ─── Loading ─────────────────────────────────────────────────────────── */\n.loading-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 48px;\n  color: var(--text-muted);\n  font-size: 0.9rem;\n  gap: 10px;\n}\n.spinner {\n  width: 20px; height: 20px;\n  border: 2px solid var(--border);\n  border-top-color: var(--accent);\n  border-radius: 50%;\n  animation: spin 0.7s linear infinite;\n  flex-shrink: 0;\n}\n@keyframes spin { to { transform: rotate(360deg); } }\n\n/* ─── Timeline ────────────────────────────────────────────────────────── */\n.timeline { list-style: none; position: relative; padding-left: 24px; }\n.timeline::before {\n  content: '';\n  position: absolute;\n  left: 8px; top: 0; bottom: 0;\n  width: 2px;\n  background: var(--border);\n}\n.timeline-item {\n  position: relative;\n  margin-bottom: 18px;\n  padding-left: 16px;\n}\n.timeline-item::before {\n  content: '';\n  position: absolute;\n  left: -8px;\n  top: 6px;\n  width: 10px; height: 10px;\n  border-radius: 50%;\n  background: var(--accent);\n  border: 2px solid var(--bg-surface);\n}\n.timeline-action {\n  font-size: 0.875rem;\n  color: var(--text-primary);\n  font-weight: 500;\n}\n.timeline-meta {\n  font-size: 0.75rem;\n  color: var(--text-muted);\n  margin-top: 2px;\n}\n\n/* ─── Tabs ────────────────────────────────────────────────────────────── */\n.tabs {\n  display: flex;\n  gap: 4px;\n  border-bottom: 1px solid var(--border);\n  margin-bottom: 24px;\n}\n.tab-btn {\n  padding: 10px 18px;\n  background: none;\n  border: none;\n  border-bottom: 2px solid transparent;\n  color: var(--text-muted);\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all var(--transition);\n  white-space: nowrap;\n}\n.tab-btn:hover  { color: var(--text-secondary); }\n.tab-btn.active { color: var(--accent-light); border-bottom-color: var(--accent); }\n\n/* ─── Dashboard Grid ──────────────────────────────────────────────────── */\n.dashboard-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n}\n.dashboard-grid .card { min-height: 300px; }\n\n/* ─── Charts ──────────────────────────────────────────────────────────── */\n.chart-card { padding: 18px 22px 22px; }\n.chart-title { font-size: 0.875rem; font-weight: 600; color: var(--text-secondary); margin-bottom: 18px; }\n\n/* ─── File Upload ─────────────────────────────────────────────────────── */\n.upload-zone {\n  border: 2px dashed var(--border);\n  border-radius: var(--radius-lg);\n  padding: 48px 32px;\n  text-align: center;\n  cursor: pointer;\n  transition: all var(--transition);\n  background: var(--bg-base);\n}\n.upload-zone:hover, .upload-zone.dragover {\n  border-color: var(--accent);\n  background: var(--accent-dim);\n}\n.upload-zone-icon { font-size: 3rem; margin-bottom: 12px; }\n.upload-zone p.primary { color: var(--text-primary); font-weight: 600; margin-bottom: 4px; }\n.upload-zone p.secondary { color: var(--text-muted); font-size: 0.8rem; }\n\n/* ─── Import result ───────────────────────────────────────────────────── */\n.import-result {\n  background: var(--bg-elevated);\n  border-radius: var(--radius);\n  padding: 20px;\n  margin-top: 20px;\n}\n.import-result h3 { font-size: 0.9rem; color: var(--text-primary); margin-bottom: 12px; }\n.import-stat { display: flex; justify-content: space-between; color: var(--text-secondary); font-size: 0.875rem; padding: 4px 0; }\n.import-errors { margin-top: 12px; }\n.import-error-item { font-size: 0.8rem; color: var(--danger); padding: 3px 0; }\n\n/* ─── Responsive ──────────────────────────────────────────────────────── */\n@media (max-width: 1024px) {\n  .dashboard-grid { grid-template-columns: 1fr; }\n}\n@media (max-width: 768px) {\n  .main-content { margin-left: 0 !important; }\n  .sidebar { transform: translateX(-100%); z-index: 200; }\n  .sidebar.mobile-open { transform: translateX(0); }\n  .page { padding: 16px; }\n  .stats-grid { grid-template-columns: repeat(2, 1fr); }\n  .form-row { grid-template-columns: 1fr; }\n  .page-header { flex-direction: column; align-items: stretch; }\n}\n@media (max-width: 480px) {\n  .stats-grid { grid-template-columns: 1fr; }\n  .auth-card { padding: 28px 20px; }\n}\n\n/* ─── Modal ──────────────────────────────────────────────────────────── */\n.modal-overlay {\n  position: fixed; inset: 0; z-index: 1000;\n  background: rgba(0,0,0,0.55);\n  backdrop-filter: blur(4px);\n  display: flex; align-items: center; justify-content: center;\n  padding: 20px;\n  animation: fadeIn 0.15s ease;\n}\n.modal {\n  background: var(--bg-elevated);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-lg);\n  width: 100%; max-height: 90vh;\n  display: flex; flex-direction: column;\n  animation: scaleIn 0.18s ease;\n}\n@keyframes scaleIn {\n  from { opacity: 0; transform: scale(0.96) translateY(8px); }\n  to   { opacity: 1; transform: scale(1) translateY(0); }\n}\n@keyframes fadeIn {\n  from { opacity: 0; } to { opacity: 1; }\n}\n.modal-header {\n  display: flex; align-items: flex-start; justify-content: space-between;\n  padding: 20px 24px 16px;\n  border-bottom: 1px solid var(--border);\n  flex-shrink: 0;\n}\n.modal-title {\n  font-size: 1.1rem; font-weight: 700; color: var(--text-primary);\n  margin: 0;\n}\n.modal-close {\n  background: none; border: none; color: var(--text-muted);\n  font-size: 1.1rem; cursor: pointer; padding: 4px 8px;\n  border-radius: var(--radius-sm); line-height: 1;\n  transition: color 0.15s, background 0.15s;\n  flex-shrink: 0; margin-left: 12px;\n}\n.modal-close:hover { color: var(--text-primary); background: var(--bg-hover); }\n.modal-body {\n  overflow-y: auto; flex: 1;\n  padding: 20px 24px;\n}\n.modal-footer {\n  display: flex; align-items: center; justify-content: flex-end; gap: 10px;\n  padding: 14px 24px;\n  border-top: 1px solid var(--border);\n  flex-shrink: 0;\n}\n\n/* ─── Upload Zone ───────────────────────────────────────────────────── */\n.upload-zone {\n  border: 2px dashed var(--border);\n  border-radius: var(--radius-lg);\n  padding: 32px 20px;\n  text-align: center;\n  cursor: pointer;\n  transition: border-color 0.2s, background 0.2s;\n}\n.upload-zone:hover, .upload-zone.dragover {\n  border-color: var(--accent);\n  background: var(--accent-dim);\n}\n.upload-zone-icon { font-size: 2.5rem; margin-bottom: 10px; }\n.upload-zone p.primary { font-weight: 600; color: var(--text-primary); margin-bottom: 4px; }\n.upload-zone p.secondary { font-size: 0.8rem; color: var(--text-muted); }\n\n/* ─── Import Result ─────────────────────────────────────────────────── */\n.import-result {\n  margin-top: 20px; padding: 16px; border-radius: var(--radius);\n  border: 1px solid var(--border); background: var(--bg-base);\n}\n.import-result h3 { font-size: 0.85rem; font-weight: 700; color: var(--text-primary); margin-bottom: 12px; }\n.import-stat {\n  display: flex; justify-content: space-between;\n  font-size: 0.83rem; color: var(--text-muted);\n  padding: 6px 0; border-bottom: 1px solid var(--border);\n}\n.import-errors { margin-top: 10px; }\n.import-error-item { font-size: 0.75rem; color: var(--danger); padding: 2px 0; }\n\n/* ─── Misc badge ────────────────────────────────────────────────────── */\n.badge--danger { background: rgba(239,68,68,.12); color: #ef4444; }\n.badge--followup { background: rgba(245,158,11,.12); color: #f59e0b; }\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
